import React, { Fragment, useState } from "react";
import { useHistory } from "react-router-dom";
import { Button, Row, Input, Form } from "antd";

import { getUrl, requests } from "../../globals/requests";
import userUtil from "../../utils/userUtil";
import logo from "../../assets/logos/logo-transparent.png";
import "./index.css";
import helpers from "../../utils/helpers";

const FormItem = Form.Item;

function Login(props) {
  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState({
    email: "",
    password: "",
  });
  const history = useHistory();

  async function handleLogin(e) {
    e.preventDefault();
    try {
      setLoading(true);
      const url = `${getUrl("users")}/login`;
      const response = await requests.post(url, formValues);
      const { token } = response.data;
      await userUtil.setUserToken(token);

      history.push("/dashboard");
    } catch (e) {
      helpers.displayMessage(e);
      setLoading(false);
    }
  }

  function handleChange(e) {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  }

  return (
    <Fragment>
      <div className="form">
        <div className="logo">
          <img alt="logo" src={logo} />
        </div>
        <Form onFinish={handleLogin}>
          <FormItem name="email" rules={[{ required: true }]} hasFeedback>
            <Input
              name="email"
              value={formValues.email}
              placeholder="email"
              onChange={handleChange}
            />
          </FormItem>
          <FormItem name="password" rules={[{ required: true }]} hasFeedback>
            <Input
              type="password"
              name="password"
              value={formValues.password}
              placeholder="Password"
              onChange={handleChange}
              password
            />
          </FormItem>
          <Row>
            <Button
              onClick={handleLogin}
              type="primary"
              htmlType="submit"
              loading={loading}
              // loading={loading.effects.login}
            >
              Sign In
            </Button>
          </Row>
        </Form>
      </div>
    </Fragment>
  );
}

export default Login;
